//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { BModal } from 'bootstrap-vue'

export default {

    components:  { BModal },

    props: {
        eventId: {
            default: false
        },
    },

    data() {
        return {
            event: false,
        }
    },

    watch: {

        eventId: function (newId, oldId) {

            if(newId === false) {
                return
            }

            if(newId == oldId) {
                return
            }

            this.getEvent(newId)
        }
    },

    methods: {

        showModal: function () {
            this.$refs.modalDetail.show()
        },

        hideModal: function () {
            this.$refs.modalDetail.hide()
        },

        onHide: function() {
            this.$emit('modal-hide')
        },

        hideModalClick: function () {
            if(this.$refs.modalDetail) {
                this.$refs.modalDetail.hide()
            }
        },

        getEvent: function (eventId) {

            this.showModal()

            var _this = this;

            this.$waiter.start('media/event-modal')

            this.$store.cache.dispatch('media/GET_EVENT', this.eventId)
            .then(function (response) {

                if (_this.$helper.isEmpty(response) === false) {
                    _this.event = response.event
                }
            })
            .catch(function (error) {
                _this.$sentry.captureException(error)
            })
            .then(function () {
                _this.$waiter.end('media/event-modal')
            });
        },


        urlSlug: function (name) {

            if(typeof name === 'undefined') {
                return name
            }

            return this.$helper.url_slug(name)

        },

    },

}

